module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/pleasant/db73a8db92395a9560fd4d56139701af.png";